var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.842,
    height: 23.991,
    viewBox: "0 0 11.842 23.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-left",
    d: "M17.921,22.5a1.5,1.5,0,0,0-.44-1.06L9.809,13.768a2.5,2.5,0,0,1,0-3.536l7.662-7.667A1.5,1.5,0,1,0,15.35.444L7.688,8.105a5.506,5.506,0,0,0,0,7.779l7.672,7.672A1.5,1.5,0,0,0,17.921,22.5Z",
    transform: "translate(-6.079 -0.004)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e2c7a3823a551df6409b0e8088e0a360.svg";
export { ForwardRef as ReactComponent };